import React, { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
//Primereact
import { Button } from "primereact/button";

//components
import Select from "../../../../components/input/Select";
import Input from "../../../../components/input/Input";
import NumberInput from "../../../../components/input/NumberInput";
import TextareaInput from "../../../../components/input/TextareaInput";
//services
import { onSubmitLand } from "../../../../services/Register/CreateLand";
//context
import { useAppContext } from "../../../../context/AppContext";

export const PanelCreateLand = ({ blocks, refetch, refresh }) => {
  const { nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const form = useForm();
  const errors = form.formState.errors;
  const [loading, setLoading] = useState(false);

  const sendLand = async (data) => {
    const notification = toast.loading("Por Favor Aguarde ...");
    setLoading(true);
    
    const sendData = {
      ...data,
      value: data.value.toFixed(2)
    }

    try {
      await onSubmitLand(sendData);
      toast.update(notification, {
        render: `${nomenclature[1].value} cadastrado com sucesso!`,
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      // Verifica se a resposta da API contém a estrutura esperada
      const errorMessage = error.response?.data?.errors?.value?.[0] || "Erro desconhecido";

      toast.update(notification, {
        render: `Falha ao cadastrar ${nomenclature[1].value}: ${errorMessage}`,
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    }

    form.reset();

    // setVisible(true);
    // form.resetField("name")
    // form.resetField("m2")
    // form.resetField("value")
    // formLand.reset();
    setLoading(false);
    refetch();
    refresh();
  };

  return (
    <form onSubmit={form.handleSubmit(sendLand)} autoComplete="off">
      <div className="row d-flex mt-4">
        <div className="col-md-3 form-group">
          <Select
            name="block_id"
            label={loading ? "Carregando..." : `${nomenclature[0].value}*`}
            errors={errors}
            control={form.control}
            options={
              blocks &&
              Object.keys(blocks).map((index) => {
                const dado = blocks[index];
                return {
                  value: dado.id,
                  label: dado.name,
                };
              })
            }
            disabled={loading}
            isRequired={true}
          />
        </div>
        <div className="col-md-3">
          <Input
            name="name"
            label={`${nomenclature[1].value}*`}
            className="w-100"
            errors={errors}
            control={form.control}
            rules={{
              required: `O Campo ${nomenclature[1].value} é Obrigatório`,
            }}
            maxLength={20}
          />
        </div>
        <div className="col-md-3 form-group">
          <NumberInput
            name="m2"
            label="M²*"
            className="w-100"
            errors={errors}
            control={form.control}
            maxFractionDigits={2}
            required={true}
          />
        </div>
        <div className="col-md-3 form-group">
          <NumberInput
            name="value"
            label="Valor*"
            className="w-100"
            error={errors}
            control={form.control}
            mode="currency"
            currency="BRL"
            locale="pt-BR"
            useGrouping={true}
            minFractionDigits={2}
            maxFractionDigits={2}
            required={true}
          />
        </div>
        <div className="col-md-3 mt-4 form-group">
          <Input
            name="address"
            label={`Endereço do ${nomenclature[1].value}`}
            className="w-100"
            // errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-3 mt-4 form-group">
          <Input
            name="num_register"
            label="Número de Matrícula"
            className="w-100"
            // errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-3 mt-4 form-group">
          <Input
            name="city_hall_register"
            label="Cadastro Prefeitura"
            className="w-100"

            // errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-3 mt-4 form-group">
          <NumberInput

            minFractionDigits={2}
            maxFractionDigits={2}
            name="front_measurement"
            label="Metragem da Frente"
            className="w-100"
            errors={false}
            control={form.control}
          />
        </div>
        <div className="col-md-3 mt-4 form-group">
          <NumberInput

            minFractionDigits={2}
            maxFractionDigits={2}
            name="bottom_measurement"
            label="Metragem do Fundo"
            className="w-100"
            errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-3 mt-4 form-group">
          <NumberInput

            minFractionDigits={2}
            maxFractionDigits={2}
            name="right_measurement"
            label="Metragem do lado Direito"
            className="w-100"
            errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-3 mt-4 form-group">
          <NumberInput

            minFractionDigits={2}
            maxFractionDigits={2}
            name="left_measurement"
            label="Metragem do lado Esquerdo"
            className="w-100"
            errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-3 mt-4 form-group">
          <NumberInput

            minFractionDigits={2}
            maxFractionDigits={2}
            name="corner_measurement"
            label="Metragem da Esquina"
            className="w-100"
            // errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-3 mt-4 form-group">
          <Input
            name="front_confrontation"
            label="Confrontação da Frente"
            className="w-100"
            // errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-3 mt-4 form-group">
          <Input
            name="bottom_confrontation"
            label="Confrontação da Fundo"
            className="w-100"
            errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-3 mt-4 form-group">
          <Input
            name="right_confrontation"
            label="Confrontação do lado Direito"
            className="w-100"
            errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-3 mt-4 form-group">
          <Input
            name="left_confrontation"
            label="Confrontação do lado Esquerdo"
            className="w-100"
            errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-12 my-3 form-group">
          <Input
            name="others_confrontation"
            label="Outras confrontações"
            className="w-100"
            errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-12 form-group my-3">
          <TextareaInput
            name="descriptive_memorial"
            label={`Memorial do ${nomenclature[1].value}`}
            className="w-100"
            errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-md-12 mb-2 form-group my-3">
          <TextareaInput
            name="obs"
            label="Observação"
            className="w-100"
            control={form.control}
          />
        </div>
        <div className="text-center">
          <Button
            rounded
            type="submit"
            loading={loading}
            label="Cadastrar"
            icon="fa fa-plus"
            className="p-inputtext-sm m-auto"
          />
        </div>
      </div>
    </form>
  );
};
